module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group esma_form_group"
  }, [(_vm.showLabel) ? _c('label', {
    staticClass: "col-xs-4 control-label esma_form_label",
    attrs: {
      "for": _vm.fieldID
    }
  }, [_vm._v(_vm._s(_vm.fieldLabel))]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.fieldClass,
    staticStyle: {
      "padding": "1px 0px 1px 7px"
    }
  }, [_c('datetimepicker', {
    attrs: {
      "disabled-picker": _vm.isDisabled,
      "disabled": _vm.isDisabled,
      "input-style": _vm.disabledStyle + ';height: 24px!important;' + _vm.filedStyle,
      "input-button-style": _vm.buttonStyle,
      "input-class": " form-control force-white",
      "id": _vm.fieldID,
      "name": _vm.fieldID,
      "value": _vm.fieldValue,
      "placeholder": "",
      "calendar-style": "left:-100px;"
    },
    on: {
      "input": _vm.updateValue
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1dea290f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fields/datetime-box.vue
// module id = 942
// module chunks = 0